import React from 'react';
import Switch from '@material-ui/core/Switch';
import { useDispatch, useSelector } from 'react-redux';
import { setGetBet } from '../../store/thunk/setGetBet';
import {useStyles} from './helper';
import {getDateFormManually, getDateForm} from '../../../../../@casino/lib/getDate';
import {useFormik, FormikContext} from "formik";

const Bet = ({groups}) => {
    const dispatch = useDispatch();
    const classes = useStyles();

    React.useEffect(() => {
        dispatch(setGetBet({
            groups,
            date_from: 0,
            date_to: new Date().getTime(),
        }))
    }, [groups]);

    const initialValues = {
        check: false,
        date_from: NaN,
        date_to: NaN
    }

    const formik = useFormik({initialValues});
    const bet = useSelector(state => state.groups.bet);
    
    return (
        <div>
            <div >
                <FormikContext.Provider value={formik} >
                    <form className={classes.wrapFilter}>
                        <label htmlFor="check" className={classes.wrapSwitch}>
                            <span className={classes.manuallyHelper}>Ручн. время</span>
                            <Switch
                                checked={formik.values.check}
                                onChange={() => formik.setFieldValue('check', !formik.values.check)}
                                color="primary"
                                name="checkedB"
                                inputProps={{ 'aria-label': 'primary checkbox' }}
                            />
                        </label>
                        <span className={classes.spo}>С</span>
                        <input 
                            type={formik.values.check ? 'datetime-local' : 'date' }
                            className={classes.inp}
                            value={formik.values.check ? getDateForm(+formik.values.date_from) : getDateFormManually(+formik.values.date_from)}
                            onChange={(v) => {
                                const date = new Date(v.target.value);
                                if (!formik.values.check) {
                                    date.setHours(0);
                                    date.setMinutes(0);
                                    date.setSeconds(0);
                                    date.setMilliseconds(0);
                                }
                                formik.setFieldValue('date_from', date.getTime());
                                dispatch(setGetBet({
                                    groups,
                                    date_from: date.getTime(),
                                    date_to: !isNaN(formik.values.date_to) ? formik.values.date_to : new Date().getTime(),
                                }))
                            }}
                        />
                        <span className={classes.spo}>ПО</span>
                        <input 
                            type={formik.values.check ? 'datetime-local' : 'date' }
                            className={classes.inp}
                            value={formik.values.check ? getDateForm(+formik.values.date_to) : getDateFormManually(+formik.values.date_to)}
                            onChange={(v) => {
                                const date = new Date(v.target.value);
                                if (formik.values.check) {
                                    date.setHours(23);
                                    date.setMinutes(59);
                                    date.setSeconds(59);
                                    date.setMilliseconds(999);
                                }
                                formik.setFieldValue('date_to', date.getTime());
                                dispatch(setGetBet({
                                    groups,
                                    date_from: !isNaN(formik.values.date_from) ? formik.values.date_from : 0,
                                    date_to: date.getTime(),
                                }))
                            }}
                        />
                    </form>
                </FormikContext.Provider>
            </div>
            <div className={classes.wrapPanel}>
                <div className={classes.block}>
                    <span className={classes.blockText}>Сумма ставок</span>
                    <span className={classes.blockText}>{new Intl.NumberFormat('ru-RU').format(bet.sumBet ? bet.sumBet.toFixed(2) : bet.sumBet)}₽</span>
                </div>
                
                <div className={classes.block}>
                    <span className={classes.blockText}>Сумма выигрышей</span>
                    <span className={classes.blockText}>{new Intl.NumberFormat('ru-RU').format(bet.sumWin ? bet.sumWin.toFixed(2) : bet.sumWin)}₽</span>
                </div>
      
              
                <div className={classes.block}>
                    <span className={classes.blockText}>Разница</span>
                    <span className={classes.blockText}>{new Intl.NumberFormat('ru-RU').format(bet.sumBet - bet.sumWin)}₽</span>
                </div>
                <div className={classes.block}>
                    <span className={classes.blockText}>Количество ставок</span>
                    <span className={classes.blockText}>{new Intl.NumberFormat('ru-RU').format(bet.countBet)}</span>
                </div>
                
            </div>
        </div>
        
    )
}

export default Bet;